import * as actionTypes from '../actions/actionType';

const browseDeveloperReducers = (state = {}, action = {}) => {
  switch (action.type) {
    case actionTypes.DEVELOPER_BROWSE:
      return action.data;
    default:
      return state;
  }
};

export default browseDeveloperReducers;
